var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291,
    height: 285,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#aa8566}.cls-4{fill:#383128}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "_521326_dining_furniture_interior_table_icon",
    "data-name": "521326_dining_furniture_interior_table_icon",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 145.5,
    cy: 142.5,
    rx: 145.5,
    ry: 142.5,
    style: {
      fill: "#f0efd2"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(135.8 104.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    className: "cls-3",
    transform: "translate(3.199 3.5)",
    d: "M0 0h13v101H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    className: "cls-4",
    d: "M58.167 140.667H45.233A3.2 3.2 0 0 1 42 137.5V36.167A3.2 3.2 0 0 1 45.233 33h12.934a3.2 3.2 0 0 1 3.233 3.167V137.5a3.2 3.2 0 0 1-3.233 3.167zm-9.7-6.333h6.467v-95h-6.467z",
    transform: "translate(-42 -33)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(90.534 162.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    className: "cls-3",
    d: "M74.267 52.2 29 95.9h18.753l26.514-25.967z",
    transform: "translate(-25.767 -49.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    className: "cls-4",
    d: "M49.986 101.233H31.233a3.231 3.231 0 0 1-2.991-1.967 3.116 3.116 0 0 1 .721-3.455l45.267-43.7a3.3 3.3 0 0 1 3.518-.668 3.173 3.173 0 0 1 1.985 2.923V72.1a3.12 3.12 0 0 1-.947 2.239L52.272 100.3a3.265 3.265 0 0 1-2.286.933zM39.119 94.9h9.525l24.622-24.112v-8.854z",
    transform: "translate(-28 -51.2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(148.733 162.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    className: "cls-3",
    d: "m47 52.2 45.267 43.7H73.513L47 69.933z",
    transform: "translate(-43.767 -49.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    className: "cls-4",
    d: "M94.565 101.233H75.747a3.254 3.254 0 0 1-2.286-.928L46.947 74.338A3.131 3.131 0 0 1 46 72.1V54.366a3.17 3.17 0 0 1 1.985-2.923 3.3 3.3 0 0 1 3.518.668l44.914 43.358a3.136 3.136 0 0 1 1.383 2.594 3.2 3.2 0 0 1-3.235 3.17zM77.085 94.9h9.525L52.467 61.934v8.854z",
    transform: "translate(-46 -51.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(58.2 91.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M180.667 42.667h-155.2A6.4 6.4 0 0 1 19 36.333 6.4 6.4 0 0 1 25.467 30h155.2a6.4 6.4 0 0 1 6.467 6.333 6.4 6.4 0 0 1-6.467 6.334z",
    transform: "translate(-15.767 -26.833)",
    style: {
      fill: "#e45544"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M182.9 48H27.7a9.5 9.5 0 1 1 0-19h155.2a9.5 9.5 0 1 1 0 19zM27.7 35.333a3.167 3.167 0 1 0 0 6.333h155.2a3.167 3.167 0 1 0 0-6.333z",
    transform: "translate(-18 -29)",
    style: {
      fill: "#3f291e"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTable);
export default __webpack_public_path__ + "static/media/createTable.8f7139b7b17eced3ee7d918599ba70a8.svg";
export { ForwardRef as ReactComponent };